module.exports = __webpack_public_path__ + "img/icon_waiting@3x.76327e87.png";